function Generatehash() {
    var token = ''; 
    var hash = '';

    var client_code = '4586';
    var project = 'shreemaruticourier';
    var encrypt = '14daf8a3b6244969d9ac951de4871eed';
    var sec_key = 'zaInK9eCX3t';
    var request_json = '{"data": {"login_username": "BELVISH.DPCLIENT", "login_password": "Belvi@123"}}';

    if (client_code && project && encrypt && sec_key) {
        hash = client_code + '|' + project + '|' + encrypt + '|' + request_json;
        token = CryptoJS.PBKDF2(hash, sec_key, { keySize: 512/32, iterations: 100000 }).toString(CryptoJS.enc.Hex);
    }

    return token;
}
